export default "__VITE_ASSET__vw3TjZMJ__"